module.exports = __webpack_public_path__ + "static/menu-wakaba-min2-c6387f624b483a4219c4a007bda2be2f.jpg";